import { PaymentTypeE } from "../../../../../models/enums";

interface ResultI {
  name: string;
  ext?: "svg" | "png" | "jpg" | "gif";
}

const getCreditCardImage = (
  creditCardBrand: string | undefined,
  paymentType?: PaymentTypeE
) => {
  const res: ResultI = {
    name: "",
    ext: "svg",
  };

  if (!creditCardBrand && paymentType === PaymentTypeE.CREDIT_CARD) return res;

  if (
    paymentType !== PaymentTypeE.PAYPAL &&
    paymentType !== PaymentTypeE.NEW_CREDIT_CARD
  ) {
    if (creditCardBrand!.toLowerCase() === "visa") {
      res.name = "purchases/visa_icon";
    } else if (creditCardBrand!.toLowerCase() === "mastercard") {
      res.name = "purchases/master_icon";
    } else if (creditCardBrand!.toLowerCase() === "old_billing") {
      res.name = "purchases/credit-card_icon";
    } else {
      res.name = "purchases/credit-card_icon";
    }
  } else if (paymentType === PaymentTypeE.PAYPAL) {
    res.name = "purchases/paypal-button";
    res.ext = "png";
  } else {
    res.name = "purchases/credit-card_icon";
  }

  return res;
};

export default getCreditCardImage;
